export default __webpack_public_path__ + "static/media/plus.95df7581.svg";